'use client';
import SafeAnchor from "./SafeAnchor.js";
export default SafeAnchor;